export default __webpack_public_path__ + "images/c5ab5cdcc7ad3a76ed24efd91685feea-thanksgiving.jpg";